<template>
  <form>
    <fieldset class="fieldset">
      <legend>{{ 'Filter'|t }}</legend>
      <div class="expanded row">
        <div class="column">
          <div class="expanded row">
            <div class="column shrink"><label for="tld" class="middle">{{ 'TLD'|t }}</label></div>
            <div class="column"><input id="tld" class="text-center" type="text" placeholder="*" v-model="filter.tld"></div>
          </div>
        </div>
        <div class="small-3 columns">
          <div class="expanded button-group">
            <button class="hollow success button" @click.prevent="submitForm()">{{ 'Submit'|t }}</button>
            <button class="hollow primary button" @click.prevent="clearForm()">{{ 'Clear'|t }}</button>
          </div>
        </div>
      </div>
      <div class="expanded row columns">
        <div class="expanded button-group">
          <button class="hollow button" v-for="ch in alphabet()" :key="ch" @click.prevent="byChar(ch)">{{ ch }}</button>
        </div>
      </div>
    </fieldset>
  </form>
</template>
<script>
  export default {
    name: 'AlphaTLDCollectionFilterForm',
    props: {
      value: {
        type: Object,
        default: () => {
          return {
            tld: "",
            letter: ""
          }
        }
      }
    },
    data() {
      return {
        filter: {
          tld: this.value.exact || ""
        }
      }
    },
    methods: {
      submitForm() {
        this.$emit('submit', this.filter)
      },
      clearForm() {
        this.filter = {
          tld: ""
        };
        this.$emit('reset', this.filter)
      },
      alphabet() {
        return 'abcdefghijklmnopqrstuvwxyz'.split('');
      },
      byChar(ch) {
        this.filter.tld = ch + '*';
        this.submitForm();
      }
    },
    watch: {
      watch: {
        filter: {
          deep: true,
          handler(to) {
            this.$emit('change', to)
          }
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/AlphaTLDCollectionFilterForm.vue